import InfoIcon from "@mui/icons-material/Info"; // Importing MUI Info icon
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import crossover_logo from "../assets/nba.svg";
import { useScreenSize } from "../hooks/useScreenSize";
import User from "./Auth/User";
import { PlayMenu } from "./Nav/PlayMenu";

const Navbar = ({ style }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const { isMobile } = useScreenSize();

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleLogoClick = () => {
    navigate("/play"); // Redirecting to /play
  };

  const modalStyles = {
    display: "flex",
    position: "fixed",
    zIndex: 1,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: "rgba(0,0,0,0.8)",
    justifyContent: "center",
    alignItems: "center",
  };

  const lightStyles = {
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #888",
  };

  const darkStyles = {
    backgroundColor: "#2A2A2A",
    color: "#fff",
    border: "1px solid #555",
  };

  const modalContentStyles = {
    margin: "auto",
    padding: "32px",
    width: "90%",
    maxWidth: "700px",
    maxHeight: "85%",
    overflowY: "auto",
    position: "relative",
    borderRadius: "16px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
  };

  const closeStyles = {
    position: "absolute",
    top: "10px",
    right: "20px",
    color: "#aaa",
    fontSize: "28px",
    fontWeight: "bold",
    cursor: "pointer",
  };

  const boardStyles = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridTemplateRows: "repeat(3, 1fr)",
    gap: "8px",
    margin: "20px auto",
    maxWidth: "220px",
    padding: "12px",
    backgroundColor: "rgba(0,0,0,0.05)",
    borderRadius: "12px",
  };

  const cellStyles = {
    width: "60px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    border: "2px solid #ddd",
    fontSize: "28px",
    fontWeight: "bold",
    borderRadius: "8px",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  };

  const headerStyles = {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "600",
    margin: "24px 0 12px 0",
  };

  const scoreboardStyles = {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    margin: "12px auto",
    maxWidth: "280px",
    padding: "12px",
    backgroundColor: "rgba(70, 130, 180, 0.08)",
    borderRadius: "10px",
  };

  const arrowStyles = (turn) => ({
    fontSize: "24px",
    fontWeight: "bold",
    color: "#4CAF50",
    marginLeft: "10px",
    marginRight: "10px",
  });

  const [moves, setMoves] = useState(["", "", "", "", "", "", "", "", ""]);
  const [currentMove, setCurrentMove] = useState(0);
  const [turn, setTurn] = useState("X");
  const [winner, setWinner] = useState("");
  const [gameIndex, setGameIndex] = useState(0);

  const games = [
    [
      { index: 0, player: "X" },
      { index: 0, player: "O" }, // Override
      { index: 1, player: "X" },
      { index: 4, player: "O" },
      { index: 2, player: "X" }, // Winning move
    ],
    [
      { index: 0, player: "X" },
      { index: 1, player: "O" },
      { index: 2, player: "X" },
      { index: 3, player: "O" },
      { index: 4, player: "X" },
      { index: 5, player: "O" },
      { index: 7, player: "O" }, // Losing move
    ],
    [
      { index: 0, player: "X" },
      { index: 0, player: "O" }, // Override
      { index: 1, player: "X" },
      { index: 1, player: "O" }, // Override
      { index: 2, player: "X" },
      { index: 3, player: "O" },
      { index: 4, player: "X" },
      { index: 4, player: "O" }, // Override
      { index: 5, player: "X" },
      { index: 6, player: "O" },
      { index: 8, player: "X" }, // Winning move
    ],
  ];

  useEffect(() => {
    if (currentMove < games[gameIndex].length && !winner) {
      const timeout = setTimeout(() => {
        const newMoves = [...moves];
        newMoves[games[gameIndex][currentMove].index] =
          games[gameIndex][currentMove].player;
        setMoves(newMoves);
        setTurn(turn === "X" ? "O" : "X");
        setCurrentMove(currentMove + 1);
        checkWinner(newMoves);
      }, 1000);

      return () => clearTimeout(timeout);
    } else if (currentMove >= games[gameIndex].length) {
      const timeout = setTimeout(() => {
        setCurrentMove(0);
        setMoves(["", "", "", "", "", "", "", "", ""]);
        setTurn("X");
        setWinner("");
        setGameIndex((gameIndex + 1) % games.length);
      }, 2000);

      return () => clearTimeout(timeout);
    }
  }, [currentMove, turn, winner]);

  const checkWinner = (moves) => {
    const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (moves[a] && moves[a] === moves[b] && moves[a] === moves[c]) {
        setWinner(moves[a]);
        return;
      }
    }
  };

  return (
    <>
      <nav
        className="navbar"
        style={{
          marginTop: 0,
          paddingLeft: 10,
          paddingRight: 10,
          backgroundColor: "#2A2A2A80",
          borderBottom: "1px solid lightgrey",
          alignSelf: "flex-start",
          ...style,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer", // Adding cursor pointer to indicate clickable area
          }}
          onClick={handleLogoClick} // Adding click handler
        >
          <img src={crossover_logo} alt="Logo" width={"30px"} height={"30px"} />
          {!isMobile && (
            <p
              style={{
                marginLeft: "10px",
                fontWeight: "bold",
                fontSize: 20,
                marginTop: "0px",
                marginBottom: "0px",
                color: "white",
              }}
              className="scoreboard-font"
            >
              CROSSOVER LIVE
            </p>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <PlayMenu />
          <User />
          <button
            onClick={openModal}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              ...(isMobile ? { padding: 0 } : {}),
            }}
          >
            <InfoIcon style={{ color: "white" }} />
          </button>
        </div>
      </nav>

      {modalOpen && (
        <div style={modalStyles} onClick={closeModal}>
          <div
            style={{
              ...modalContentStyles,
              ...(document.documentElement.classList.contains("dark")
                ? darkStyles
                : lightStyles),
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <span style={closeStyles} onClick={closeModal}>
              &times;
            </span>
            <h1 style={{
              fontSize: '28px',
              marginBottom: '8px',
              background: 'linear-gradient(135deg, #4682B4 0%, #5b9bd5 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Crossover Live: How to Play
            </h1>
            <p style={{
              fontSize: '16px',
              marginBottom: '24px',
              opacity: 0.85
            }}>
              Real-time multiplayer trivia tic-tac-toe
            </p>

            <div style={{
              backgroundColor: 'rgba(70, 130, 180, 0.1)',
              padding: '20px',
              borderRadius: '12px',
              marginBottom: '24px',
              border: '1px solid rgba(70, 130, 180, 0.3)'
            }}>
              <h3 style={{ fontSize: '18px', marginTop: 0, marginBottom: '16px' }}>⚡ Quick Start</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <strong style={{ fontSize: '15px' }}>📋 Selection:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    Pick a cell and choose a player, movie, or Pokémon that fits BOTH the row and column criteria.
                  </p>
                </div>
                <div>
                  <strong style={{ fontSize: '15px' }}>🔄 Unlimited Override:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    Override your opponent's cells with another qualifying choice. Cells can be overridden endlessly!
                  </p>
                </div>
              </div>
            </div>

            <div style={headerStyles}>🎮 Live Game Preview</div>
            <div style={scoreboardStyles}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ margin: '5px' }}>Home (X)</p>
                {turn === "X" && <p style={arrowStyles(turn)}>←</p>}
                <p></p>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <p></p>
                {turn === "O" && <p style={arrowStyles(turn)}>→</p>}
                <p style={{ margin: '5px' }}>Away (O)</p>
              </div>
            </div>
            <div style={boardStyles}>
              {moves.map((move, index) => (
                <div key={index} style={cellStyles}>
                  {move}
                </div>
              ))}
            </div>
            {winner && (
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: '16px',
                  margin: '12px 0',
                  color:
                    winner === "Draw"
                      ? "gray"
                      : winner === "X"
                      ? "#4682B4"
                      : "#e74c3c",
                }}
              >
                {winner === "Draw"
                  ? "It's a Draw!"
                  : winner === "X"
                  ? "Home Wins!"
                  : "Away Wins!"}
              </p>
            )}

            <div style={{
              marginTop: '24px',
              padding: '20px',
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              borderRadius: '12px',
              border: '1px solid rgba(76, 175, 80, 0.3)'
            }}>
              <h3 style={{ fontSize: '18px', marginTop: 0, marginBottom: '16px' }}>🏆 Game Rules</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <strong style={{ fontSize: '15px' }}>🎯 Winning:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    Connect three of your choices in a row—horizontally, vertically, or diagonally. Full board without a winner = draw.
                  </p>
                </div>
                <div>
                  <strong style={{ fontSize: '15px' }}>⏰ Time Limit:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    Each turn = 24 seconds. Time out and you lose your turn!
                  </p>
                </div>
                <div>
                  <strong style={{ fontSize: '15px' }}>🕰️ Franchise History:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    Remember franchise histories! Expos players = Nationals, Browns players = Orioles, etc.
                  </p>
                </div>
                <div>
                  <strong style={{ fontSize: '15px' }}>🔄 Rematch:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    After the game, challenge your opponent to an instant rematch!
                  </p>
                </div>
                <div>
                  <strong style={{ fontSize: '15px' }}>🏅 Leaderboard:</strong>
                  <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.85 }}>
                    Earn ELO points for wins and climb the global leaderboard!
                  </p>
                </div>
              </div>
            </div>

            <p style={{
              textAlign: 'center',
              marginTop: '24px',
              fontSize: '15px',
              fontStyle: 'italic',
              opacity: 0.9
            }}>
              🎲 Combining sports trivia, movie knowledge, and Pokémon mastery with fast-paced strategy. Game on!
            </p>

            <div style={{
              marginTop: '32px',
              padding: '20px',
              backgroundColor: 'rgba(155, 89, 182, 0.1)',
              borderRadius: '12px',
              border: '1px solid rgba(155, 89, 182, 0.3)'
            }}>
              <h3 style={{ fontSize: '18px', marginTop: 0, marginBottom: '16px' }}>📧 Contact Us</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '14px' }}>
                <div>
                  <strong>🐛 Report a Bug / Feedback:</strong> <a href="mailto:Feedback@crossovergrid.com" style={{ color: '#4682B4', textDecoration: 'none' }}>Feedback@crossovergrid.com</a>
                </div>
                <div>
                  <strong>🤝 Sponsorships:</strong> <a href="mailto:Sponsorships@crossovergrid.com" style={{ color: '#4682B4', textDecoration: 'none' }}>Sponsorships@crossovergrid.com</a>
                </div>
                <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                  <a
                    href="https://twitter.com/CrossoverGrid"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#4682B4', textDecoration: 'none', fontWeight: '500' }}
                  >
                    🐦 Twitter
                  </a>
                  <a
                    href="https://instagram.com/CrossoverGrid"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#4682B4', textDecoration: 'none', fontWeight: '500' }}
                  >
                    📸 Instagram
                  </a>
                  <a
                    href="https://tiktok.com/@CrossoverGrid"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#4682B4', textDecoration: 'none', fontWeight: '500' }}
                  >
                    🎵 TikTok
                  </a>
                  <a
                    href="https://threads.net/@CrossoverGrid"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#4682B4', textDecoration: 'none', fontWeight: '500' }}
                  >
                    🧵 Threads
                  </a>
                  <a
                    href="https://CrossoverGrid.com"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#4682B4', textDecoration: 'none', fontWeight: '500' }}
                  >
                    🌐 Website
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
